import React from "react";
import { useParams } from "react-router-dom";
import { Work } from "../../types/work";
import AddEditWorkForm from "./AddEditWorkForm";
import AncillarySection from "./sections/AncillarySection";
import TranslationSection from "./sections/TranslationOfWorkSection";
import VersionsSection from "./sections/VersionSection";
import useWorkLogic from "../../hooks/logic/workLogic";

interface AddEditWorkPageProps {
  systemLanguageType: Work["system_language_type"];
}

const AddEditWorkPage: React.FC<AddEditWorkPageProps> = ({
  systemLanguageType,
}) => {
  const { _id = null } = useParams<{
    _id?: string;
  }>();
  const {
    showAncillaryConnectionSection,
    showVersionTable,
    showWorkTranslationTable,
  } = useWorkLogic(systemLanguageType);

  return (
    <AddEditWorkForm
      _id={_id || null}
      systemLanguageType={systemLanguageType}
      sections={(work: Work) => [
        ...(showVersionTable
          ? [<VersionsSection key="versions" work={work} />]
          : []),
        ...(showWorkTranslationTable
          ? [<TranslationSection key="translations" work={work} />]
          : []),
        ...(showAncillaryConnectionSection
          ? [
              <AncillarySection
                key="ancillary"
                work={work}
                systemLanguageType={systemLanguageType}
              />,
            ]
          : []),
      ]}
    />
  );
};

export default AddEditWorkPage;
